import { css } from "@emotion/react";

const warningBanner = css`
  margin-bottom: 8px;
  p[class*="styles_BannerDescription"] {
    margin-bottom: 0;
  }
`;

const positionLink = css`
  color: black;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
    color: darkgray;
  }
`;

const fullScreenTakeover = css`
  position: absolute;
  top: 0;
  z-index: 1000;

  header[class*="styles_Header"] {
    padding-top: 7px;
    padding-bottom: 7px;
    /* this is to ensure UI shows multiple spaces we have in the string */
    white-space: pre;
  }

  div[class*="styles_Takeover__subheader"] {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const gridViewport = css`
  div[class*="ag-center-cols-viewport"] {
    min-height: unset !important;
  }
`;

export default { warningBanner, positionLink, fullScreenTakeover, gridViewport };
